<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="系列名称">
            <el-input
              v-model="queryForm.name"
              placeholder="请输入系列名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" 
              v-hasPermi="['Island:cardlist:add']"
              icon="el-icon-plus"
            type="primary">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="系列名称"
          prop="name"
          height="500"
        />
        <el-table-column
          align="center"
          label="创建日期"
          width="180"
        >
          <template #default="{ row }">
            <p>{{ transTime(row.insert_time) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="等级"
          height="500"
        >
          <template #default="{ row }"> 
            <span v-if="row.level_list">{{ JSON.parse(row.level_list).join(',') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          height="500"
        >
          <template #default="{ row }">
            <span>{{ row.is_on_sale ? '上架' : '下架' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:cardlist:edit']"
             @click="handleEdit(row)"
            >
              <span>编辑</span>
            </el-button>
            <el-button
              size="small"
              v-hasPermi="['Island:cardlist:delete']"
              type="danger"
             @click="handleDelete(row)"
             >
              删除
            </el-button>
            <el-button
              size="small"
              v-hasPermi="['Island:cardlist:detail']"
              type="warning"
              @click="handleDetail(row)"
              >
              卡牌详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
    <el-dialog
      title="是否确认退款？"
      :visible.sync="dialogVisible"
      width="20%"
      center
    >
    </el-dialog>
  </div>
</template>

<script>
import { getSeriesList, delSeries } from '@/api/radio'
import { transTime } from '@/utils/transTime'

export default {
  data() {
    return {
      transTime,
      queryForm: {
        page: 1,
        pageSize: 10,
        name: '',
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
    };
  },
  created() {
    this.fetchData()
  },
  mounted() {},

  methods: {
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
      this.$router.push({
        path: '/seriesAdd',
        query: {
          type: 'add'
        }
      })
    },
    handleEdit(row){
      sessionStorage.setItem('series', JSON.stringify(row))
      this.$router.push({
        path: '/seriesAdd',
        query: {
          type: 'edit',
        }
      })
    },
    handleDelete(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSeries({id: row.id}).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        }).catch(err => {
          this.$message({
            type: 'info',
            message: err.msg
          });
        })
      }).catch(() => {
      })
    },
    handleDetail(row){
      this.$router.push({
        path: '/cardDetail',
        query: {
          row: JSON.stringify(row)
        }
      })
    },
    async fetchData() {
      // 这里发请求
      let params = {
        name: this.queryForm.name,
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      await getSeriesList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>

.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
</style>